import Cookies from 'js-cookie';
import actionTypes from './actionTypes';
import moment from 'moment';

const initialState = {
  token: Cookies.get("token"),
  loading: false,
  editMode: false,
  showModal: false,
  errors: {},
  message: null,

  tournament: null,
  tournaments: [],
  date_started: moment(),
  file: null,
  status: 'public',
  link: null,
  title: '',

};


export default function reducer(state=initialState, action) {
  switch (action.type) {

    case actionTypes.TOURNAMENTS_SET_INITIAL:
      const emptyPartner = {
        editMode: false,
        tournament: null,
        date_started: moment(),
        file: null,
        status: 'public',
        link: null,
        title: '',
      };
      return {...state, ...emptyPartner};

    case actionTypes.LOADING:
      return {...state, loading: action.loading};

    case actionTypes.SET_TOURNAMENTS:
      return {...state, tournaments: action.tournaments};

    case actionTypes.TOURNAMENTS_SHOW_FORM:
      return {...state, showModal: true};

    case actionTypes.TOURNAMENTS_HIDE_FORM:
      return {...state, showModal: false};

    case actionTypes.SHOW_MESSAGE:
      return {...state, message: action.message};

    case actionTypes.TOURNAMENTS_SET_FILE:
      return {...state, loading: false, file: action.file};

    case actionTypes.TOURNAMENTS_CHANGE_INPUT:
      return {...state, [action.name]: action.value};

    case actionTypes.TOURNAMENTS_SET_ERRORS:
      return {...state, errors: action.errors};

    case actionTypes.TOURNAMENTS_SET:
      const item = {...action.tournament};
      item['date_started'] = moment(action.tournament.date_started);
      return {...state, ...item, tournament: action.tournament, editMode: true};

    default:
      return state;
  }
}
